import { useContext } from 'react';

import SettingsContext, { SettingsContextValue } from 'src/contexts/settings';

const useSettings = (): SettingsContextValue => useContext(SettingsContext);

export default useSettings;
